<template>
	<div class="product-post" @click="$emit('click', $event = true); checkUrl(product.id); triggerFirst()" :data-product-id="product.id">
		{{checkPopup(product.id)}}
<!--		class="product-post__item"-->
		<a v-if="product.is_package === false" class="product-post__item" :data-product-id="product.id">
			<div class="product-post__img-cont">
				<img v-bind:class="[product.is_contain ? 'img-contain' : 'cover-img']" :src="product.image" alt="">
			</div>
			<div class="product-post__text">
				<h3 class="product-post__name">{{ product.title }}</h3>
<!--				product-post__details-->
				<span class="product-post_details">
					<span v-if="product.attributes.length < 1" class="product-post__price color-burning-orange">${{ product.price }}</span>
					<span v-if="product.attributes.length > 0" class="product-post__price color-burning-orange">${{ product.price }}+</span>
					<span v-if="hasFeeds" class="product-post__feed color-happy-blue">
						<SvgIcon class="product-post__ico-users" iconName="ico-users"/>
						<span v-if="product.attributes.length < 1">Feeds {{ getMinMaxFeedsSimpleProduct() }}</span>
						<span v-if="product.attributes.length > 0">Feeds {{ getMinMaxFeedsVarProduct() }}</span>
					</span>
				</span>
			</div>
		</a>
		<a v-if="product.is_package" class="product-post__item" :href="product.url">
			<div class="product-post__img-cont">
				<img v-bind:class="[product.isContain ? 'img-contain' : 'cover-img']" :src="product.image" alt="">
			</div>
			<div class="product-post__text">
				<h3 class="product-post__name">{{ product.title }}</h3>

				<span class="product-post__details">
					<span class="product-post__price color-burning-orange">${{ product.price }}+</span>
					<span v-if="getMinMaxFeedsSimpleProduct() > 0 || getMinMaxFeedsVarProduct() > 0" class="product-post__feed color-happy-blue">
						<SvgIcon class="product-post__ico-users" iconName="ico-users"/>
						<span v-if="product.attributes.length < 1">Feeds {{ getMinMaxFeedsSimpleProduct() }}</span>
						<span v-if="product.attributes.length > 0">Feeds {{ getMinMaxFeedsVarProduct() }}</span>
					</span>
				</span>
			</div>
		</a>
		<div v-if="product.short_info" class="product-post__note-wrap">
			<div class="product-post__note">
				<span class="product-post__note-text">{{ product.short_info }}</span>
			</div>
		</div>
	</div>
</template>

<script>
import SvgIcon from '../base/SvgIcon/SvgIcon.vue';

export default {
	components: {
		SvgIcon
	},
	props: {
		product: Object,
		isContain: String,
		hasHours: Boolean,
		hasFeeds: Boolean,
		imgName: String,
		productPopupID: Number,
		servingSize: {
			maxVal: '',
			minVal: ''
		},
	},
	mounted() {
		this.equalHeights();
	},
	methods: {
		checkPopup: function(productID) {
			if (parseInt(productID) === parseInt(this.productPopupID)) {
				this.$emit('click', true);
				this.triggerFirst();
			}
		},
		checkUrl: function(productID) {
			let url = window.location.href;
			if (url.includes('?product-popup')) {
				url = url.split('?product-popup')[0];
			}
			window.history.pushState('page', 'Title', url + '?product-popup=' + productID);
		},
		triggerFirst: function() {
			setTimeout(function(){
				const firstRadio = document.querySelectorAll('.popup-product__radio');
				if(firstRadio[0]) {
					firstRadio[0].click();
				}
			}, 500);
		},
		getMinMaxFeedsSimpleProduct: function() {
			const feeds = this.product.feeds_number;
			// if (feeds.includes('-')) {
			// 	feeds = this.product.feeds_number.split('-');
			// 	return feeds[0] + '+';
			// }
			return feeds;
		},
		getMinMaxFeedsVarProduct: function() {
			const attributes = this.product.attributes;
			const feeds = [];
			for (let i = 0; i < attributes.length; i++) {
				feeds.push(parseInt(attributes[i].serving_size));
			}
			this.maxVal = Math.max.apply(Math, feeds);
			this.minVal = Math.min.apply(Math, feeds);
			return this.minVal + '+ ';
			//+ this.maxVal
		},
		/**
		 * @description add equal height to products
		 */
		equalHeights: () => {
			/* if (window.innerWidth > 768) {
				setTimeout(() => {
					const products = document.getElementsByClassName('product-post__item');
					let x = 0;

					Array.from(products).forEach((el) => {
						el.style.height = 'auto';

						if (el.offsetHeight > x) {
							x = el.offsetHeight;
						}
					});

					Array.from(products).forEach((el) => {
						el.style.height = `${x}px`;
					});

				}, 100);
			} */
		},
	}
};
</script>

<style lang="scss" scoped>

.product-post__details {
	display: flex;
	justify-content: center;
	align-items: center;
	max-width: 100%;
	position: absolute;
	bottom: 40px;
	left: 0;
	width: 100%;
	padding: 0 32px;

		@media all and (-ms-high-contrast: none), (-ms-high-contrast: active) { //sass-lint:disable-line no-vendor-prefixes
			justify-content: flex-start;
		}

	@include mq(1024px) {
		padding: 0 15px;
	}
}

@media not all and (min-resolution: .001dpcm) {
	@supports (-webkit-appearance:none) {
		.product-post__details {
			max-height: 32px;
		}
	}
}


.item-listing__mobile-prod {

	.product-post__item {
		display: flex !important;//sass-lint:disable-line no-important
	}
}

.product-post {
	position: relative;
	width: calc(25% - 21px);
	margin-bottom: 50px;
	filter: drop-shadow(10px 10px 30px rgba($cello, 0.1));
	background-color: transparent;
	display: flex;
	flex-direction: column;

	&:not(:nth-child(4n)) {
		margin-right: 28px;
	}

	@include mq($lg) {
		width: calc(33.33% - 14px);
		margin-bottom: 30px;
		&:not(:nth-child(4n)) {
			margin-right: 0;
		}
		&:not(:nth-child(3n)) {
			margin-right: 21px;
		}
	}

	@include mq($md) {
		width: calc(50% - 10.5px);
		margin-bottom: 30px;
		&:not(:nth-child(3n)) {
			margin-right: 0;
		}
		&:not(:nth-child(2n)) {
			margin-right: 21px;
		}
	}
	@include mq($sm) {
		width: 100%;
		max-width: 300px;
		margin-bottom: 30px;
		&:not(:nth-child(2n)) {
			margin-right: 0;
		}
		margin-left: auto !important;
		margin-right: auto !important;
	}
}

.product-post__item {
	display: block;
	background-color: $white;
	width: 100%;
	-webkit-clip-path: polygon(
			0 0,
			3.57% 10px,
			7.14% 0,
			10.71% 10px,
			14.29% 0,
			17.86% 10px,
			21.43% 0,
			25% 10px,
			28.57% 0,
			32.14% 10px,
			35.71% 0,
			39.29% 10px,
			42.86% 0,
			46.43% 10px,
			50% 0,
			53.57% 10px,
			57.14% 0,
			60.71% 10px,
			64.29% 0,
			67.86% 10px,
			71.43% 0,
			75% 10px,
			78.57% 0,
			82.14% 10px,
			85.71% 0,
			89.29% 10px,
			92.86% 0,
			96.43% 10px,
			100% 0,
			100% 100%,
			96.43% calc(100% - 10px),
			92.86% 100%,
			89.29% calc(100% - 10px),
			85.71% 100%,
			82.14% calc(100% - 10px),
			78.57% 100%,
			75% calc(100% - 10px),
			71.43% 100%,
			67.86% calc(100% - 10px),
			64.29% 100%,
			60.71% calc(100% - 10px),
			57.14% 100%,
			53.57% calc(100% - 10px),
			50% 100%,
			46.43% calc(100% - 10px),
			42.86% 100%,
			39.29% calc(100% - 10px),
			35.71% 100%,
			32.14% calc(100% - 10px),
			28.57% 100%,
			25% calc(100% - 10px),
			21.43% 100%,
			17.86% calc(100% - 10px),
			14.29% 100%,
			10.71% calc(100% - 10px),
			7.14% 100%,
			3.57% calc(100% - 10px),
			0% 100%
	);

	clip-path: polygon(
			0 0,
			3.57% 10px,
			7.14% 0,
			10.71% 10px,
			14.29% 0,
			17.86% 10px,
			21.43% 0,
			25% 10px,
			28.57% 0,
			32.14% 10px,
			35.71% 0,
			39.29% 10px,
			42.86% 0,
			46.43% 10px,
			50% 0,
			53.57% 10px,
			57.14% 0,
			60.71% 10px,
			64.29% 0,
			67.86% 10px,
			71.43% 0,
			75% 10px,
			78.57% 0,
			82.14% 10px,
			85.71% 0,
			89.29% 10px,
			92.86% 0,
			96.43% 10px,
			100% 0,
			100% 100%,
			96.43% calc(100% - 10px),
			92.86% 100%,
			89.29% calc(100% - 10px),
			85.71% 100%,
			82.14% calc(100% - 10px),
			78.57% 100%,
			75% calc(100% - 10px),
			71.43% 100%,
			67.86% calc(100% - 10px),
			64.29% 100%,
			60.71% calc(100% - 10px),
			57.14% 100%,
			53.57% calc(100% - 10px),
			50% 100%,
			46.43% calc(100% - 10px),
			42.86% 100%,
			39.29% calc(100% - 10px),
			35.71% 100%,
			32.14% calc(100% - 10px),
			28.57% 100%,
			25% calc(100% - 10px),
			21.43% 100%,
			17.86% calc(100% - 10px),
			14.29% 100%,
			10.71% calc(100% - 10px),
			7.14% 100%,
			3.57% calc(100% - 10px),
			0% 100%
	);

	@include hover {
		.product-post__img-cont::before {
			opacity: 1;
		}
	}
}

.product-post__img-cont {
	position: relative;
	overflow: hidden;
	width: 100%;
	padding-top: 76%;

	&::before {
		content: '';
		position: absolute;
		z-index: 1;
		top: 0;
		left: 0;
		bottom: 0;
		right: 0;
		background-color: rgba($ziggurat, 0.8);
		opacity: 0;
		transition: opacity $dur $ease;
	}

	.img-contain {
		position: absolute;
		top: 50%;
		left: 50%;
		transform: translate(-50%, -50%);
		width: 100%;
		height: 80%;
		object-fit: contain;
		font-family: "object-fit: contain";
	}
}

.product-post__text {
	min-height: 180px;
	padding: 27px 32px 60px;
	@include mq($lg) {
		min-height: 161px;
	}
}

.product-post__name {
	color: $cello;
	text-align: center;
	font-size: 23px;
	font-weight: 500;
	margin-bottom: 25px;

	@include mq($lg) {
		font-size: 20px;
		margin-bottom: 20px;
	}
}

.product-post__price {
	font-size: 20px;
	letter-spacing: 0.5px;

	@include mq(1024px) {
		font-size: 17px;
	}
}

.product-post__feed {
	display: inline-flex;
	align-items: center;
	margin-left: auto;
	font-family: $font-second;
}

.product-post__ico-users {
	font-size: 18px;
	margin-right: 6px;
	height: 18px;

	@include mq(1024px) {
		font-size: 16px;
		height: 16px;
	}
}

.product-post__note-wrap {
	width: 100%;
	margin-top: -18px;
	z-index: 2;
	display: flex;
	position: relative;
}

.product-post__note {
	border: 1px solid $happy-blue;
	border-radius: 6px;
	max-width: 80%;
	width: auto;
	padding: 2px 10px;
	margin: 0 auto;
	background-color: $iceberg;
	text-align: center;
}

.product-post__note-text {
	font-size: 16px;
	color: $happy-blue;
	font-weight: 400;
	font-family: $font-second;

	@include mq(1024px) {
		font-size: 15px;
	}
}

.product-post__prep {
	display: inline-block;
	position: absolute;
	z-index: 1;
	top: 23px;
	right: -10px;
	padding: 4px 12px;
	border-radius: 4px;
	color: $burning-orange;
	background-color: $karry;
	font-family: $font-second;
	font-size: 15px;
	box-shadow: 5px 8px 15px rgba($cello, 0.07);
}

</style>
